import React from 'react'
import { Helmet } from 'react-helmet'

const PrepaidCard = () => {
  return (
    <div>
      <Helmet>
        <title>Prepaid Card | Pressto India</title>
        <meta name="description" content="Pressto India prepaid card and gift card options for laundry and dry cleaning services." />
        <link rel="canonical" href="https://www.presstoindia.com/prepaid-card" />
      </Helmet>
      PrepaidCard
    </div>
  )
}

export default PrepaidCard
